import React from "react";
import { Text } from "@mantine/core";
import { Venue, Display } from "@/utils/api";
import { ComponentType } from "../displayScreenTypes";

export interface VenueNameComponentProps {
  /** Venue data containing the name */
  venue?: Venue;

  /** Display data for fallback */
  display?: Display;

  /** Fallback component type if venue name is not available */
  fallback?: ComponentType;

  /** Additional CSS class name for styling */
  className?: string;

  /** Inline styles */
  style?: React.CSSProperties;
}

export const VenueNameComponent: React.FC<VenueNameComponentProps> = ({
  venue,
  display,
  fallback,
  className,
  style,
}) => {
  // Try to get venue name
  const venueName = venue?.name;

  // If venue name exists, show it
  if (venueName) {
    return (
      <Text
        className={className}
        style={{
          color: "inherit",
          fontSize: "inherit",
          fontWeight: "inherit",
          fontFamily: "inherit",
          lineHeight: "inherit",
          ...style,
        }}
      >
        {venueName}
      </Text>
    );
  }

  // If no venue name and fallback is display_name, show display name
  if (fallback === "display_name" && display?.name) {
    return (
      <Text
        className={className}
        style={{
          color: "inherit",
          fontSize: "inherit",
          fontWeight: "inherit",
          fontFamily: "inherit",
          lineHeight: "inherit",
          ...style,
        }}
      >
        {display.name}
      </Text>
    );
  }

  // Nothing to show
  return null;
};
